export default class Orders {
    static refreshShipping() {
        // Get shipping address ID — from #orderContext (editCompletedItems) or address selectize (order form)
        let shippingAddressId;
        let $orderContext = $('#orderContext');
        let $shippingSelect = $('#inputShipping');

        if ($orderContext.length && $orderContext.data('shipping-id')) {
            shippingAddressId = $orderContext.data('shipping-id');
        } else if ($shippingSelect.length && $shippingSelect[0].selectize) {
            shippingAddressId = $shippingSelect[0].selectize.getValue();
        }

        let APIPayload = [];

        $('[data-repeater-list="items"]').children().each((index, el) =>{
            if($('.itemType', el).val() === 'product') {
                APIPayload.push({
                    'id': $('.itemID', el).val(),
                    'quantity': $('.inputQuantity', el).val()
                });
            }
        })

        // Check for a pre-selected value from data-selected attribute
        let $shippingRateSelect = $orderContext.length ? $('#inputShipping') : $('[name="shipping_rate"]');
        let preSelected = $shippingRateSelect.data('selected');

        axios.post('/api/orders/shipping-rate', {
            products: APIPayload,
            shipping: {
                id: shippingAddressId
            },
            total: $('#total').text()
        }).then(response => {
            let $ShippingMethods = $shippingRateSelect[0].selectize;
            Object.keys(response.data).forEach(function (key) {
                $ShippingMethods.addOption(response.data[key]);

                if (preSelected && response.data[key].id == preSelected) {
                    $ShippingMethods.setValue(response.data[key].id);
                } else if (!preSelected && response.data[key].selected) {
                    $ShippingMethods.setValue(response.data[key].id);
                }
            })
        });
    }

    static initCompletedItemsShipping() {
        if ($('#orderContext').length && $('#inputShipping').length) {
            Orders.refreshShipping();
        }
    }
}

